module.exports = __webpack_public_path__ + "static/media/file-times.48455e9e.svg";